const form = document.getElementById('js-product-add-related-form');
const relatedProductCheckboxes = document.querySelectorAll(
  'input[name=related-product]'
);
const relatedProductSPCheckboxes = document.querySelectorAll(
  'input[name=related-product-sp]'
);
const totalPriceElement = document.getElementById(
  'js-product-add-related-total-price'
);
const addCartButton = document.getElementById(
  'js-product-add-related-cart-button'
);
const footerOpenButton = document.getElementById(
  'js-product-add-related-footer-open-button'
);
const xlProductsList = document.getElementById(
  'js-product-add-related-xl-list'
);

const calculateTotalPrice = (productPrice = false) => {
  let totalPrice = 0;
  for (const checkbox of relatedProductCheckboxes) {
    if (!checkbox.checked) {
      continue;
    }
    const variantID = checkbox.value;
    const price = document.getElementById(
      `js-product-add-related-product-price-value-${variantID}`
    ).value;
    totalPrice += Number(price) / 100;
  }
  // 開梱設置 値段取得
  const unpackingPrice = $('#select_unpacking option:selected').data('price');
  // e-NRG 値段取得
  const enrgPrice = $('#select_enrg option:selected').data('price');
  // アダプター 値段取得
  const adapterPrice = $('#select_adapter option:selected').data('price');
  if (unpackingPrice) {
    totalPrice += Number(unpackingPrice) / 100;
  }
  if (enrgPrice) {
    totalPrice += Number(enrgPrice) / 100;
  }
  if (adapterPrice) {
    totalPrice += Number(adapterPrice) / 100;
  }
  return totalPrice;
};

const changeProductStyle = (checkbox) => {
  const variantID = checkbox.value;
  const product = document.getElementById(
    `js-product-add-related-product-${variantID}`
  );
  if (checkbox.checked) {
    product.classList.remove('is-unchecked');
  } else {
    product.classList.add('is-unchecked');
  }
};

// PC/SPのチェックボックスを同期する
const synchronizeCheckboxes = (checkbox) => {
  const variantID = checkbox.value;
  const productCheckBoxSP = document.getElementById(
    `js-product-add-related-checkbox-sp-${variantID}`
  );
  const productCheckBox = document.getElementById(
    `js-product-add-related-checkbox-${variantID}`
  );
  productCheckBox.checked = checkbox.checked;
  productCheckBoxSP.checked = checkbox.checked;
};

// 合計金額の更新とカート追加ボタンの表示切り替え
const updateTotalPriceAndCartButton = (product_price = false) => {
  const totalPrice = calculateTotalPrice(product_price);
  let productPrice = 0;
  setTimeout(() => {
    let url = new URL(window.location.href);
    let param = url.searchParams.get('variant');
    if (!param) {
      productPrice = $(totalPriceElement).data('product-price') / 100;
    } else {
      const variantClass = $('.product_variant');
      let variantPrice = 0;
      variantClass.each(function () {
        if (Number(param) === $(this).data('product-id')) {
          variantPrice = $(this).data('product-price');
        }
      });
      productPrice += Number(variantPrice) / 100;
    }
    totalPriceElement.innerHTML = `₩${(
      totalPrice + productPrice
    ).toLocaleString()}`;
  }, '100');
  const isAllUnchecked = totalPrice === 0;
  // addCartButton.disabled = isAllUnchecked;
  // $(addCartButton).toggleClass('is-all-unchecked', isAllUnchecked);
};

const toggleCheckBox = (checkbox) => {
  changeProductStyle(checkbox);
  synchronizeCheckboxes(checkbox);
  updateTotalPriceAndCartButton();
};

const initialize = () => {
  updateTotalPriceAndCartButton();
  for (const checkbox of relatedProductCheckboxes) {
    synchronizeCheckboxes(checkbox);
  }
};

window.addEventListener('DOMContentLoaded', () => {
  if (!form) {
    return;
  }

  initialize();
  relatedProductCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      toggleCheckBox(checkbox);
    });
  });
  relatedProductSPCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      toggleCheckBox(checkbox);
    });
  });

  footerOpenButton.addEventListener('click', () => {
    footerOpenButton.style.display = 'none';
    addCartButton.style.display = 'block';
    xlProductsList.style.display = 'block';
  });
});

// 商品のバリエーション変更したら発火
const changeSelectProductVariant = () => {
  //console.log('updateSelectProductTotalPriceなに？')
  if (updateSelectProductTotalPrice()) {
    updateSelectProductTotalPrice();
  }
  //console.log('???doudesuka')
  updateTotalPriceAndCartButton(true);
};
// オプション商品を更新したら発火
const changeSelectProduct = () => {
  updateTotalPriceAndCartButton();
};
